// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","158":"labels","472":"settings","594":"about","966":"login"}[chunkId] || chunkId) + "." + {"53":"225fe581","141":"39396486","158":"ab3864e5","196":"459257fe","269":"989b6b1a","472":"46aa74eb","594":"1c963ab5","947":"e1a00a7d","966":"3a8fa077"}[chunkId] + ".js";
};